import { render, staticRenderFns } from "./LawStatisitcDetailsYearTable.vue?vue&type=template&id=788362f4&scoped=true"
import script from "./LawStatisitcDetailsYearTable.vue?vue&type=script&lang=js"
export * from "./LawStatisitcDetailsYearTable.vue?vue&type=script&lang=js"
import style0 from "./LawStatisitcDetailsYearTable.vue?vue&type=style&index=0&id=788362f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788362f4",
  null
  
)

export default component.exports